/*eslint react/no-deprecated: 0*/
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import { push } from 'react-router-redux';
import { Row, Col, Container } from 'reactstrap';

import { Field, reduxForm, FormSection, formValueSelector } from 'redux-form/immutable';

import { CancelarButtonC } from 'modules/general/component';
import { ItemListPasajeroC } from 'modules/viajes/components/itemListPasajero';
import ReservasAutomaticasTableC from './reservasAutomaticasTable';
import { EliminarConfirmacionC } from 'modules/general/component';
import { PenalizacionesUsuarioC } from 'modules/penalizaciones/component';

import AbonosC from './abonos';
import AbonoItemListC from './abonoItemList';
import * as generalActions from 'modules/general/action';
import * as abonadosActions from 'modules/abonados/action';
import * as reservasActions from 'modules/reservas/action';
import * as mensajesActions from 'modules/mensajes/action';
import * as penalizacionesActions from 'modules/penalizaciones/action';

import * as validations from 'modules/forms/validations';
import { FORM_ABONADOS } from 'modules/forms/formConstants';
import { SelectFieldF, TextFieldF, DatePickerF, ToggleFieldF } from 'modules/forms/component';

import { checkPermissions } from 'core/generalFunctions';

const DateTimeFormat = global.Intl.DateTimeFormat;
const selector = formValueSelector(FORM_ABONADOS);

moment.locale('es');

class Add extends React.Component {
  constructor(props) {
    super(props);
    this.state = { popupFlag: false };
  }
  componentDidMount() {
    const {
      params: { abonadoId, isUser },
      dispatch,
    } = this.props;
    if (abonadoId != 'new') {
      dispatch(generalActions.dashboard_changeTitle('MODIFICANDO ABONADO'));
      dispatch(abonadosActions.getReservasUsuario(abonadoId, isUser == 'true'));
      if (checkPermissions(['admin', 'administrador_abonados', 'administrador_pasajes'])) {
        dispatch(abonadosActions.getById(abonadoId, isUser == 'true'));
      }
      dispatch(mensajesActions.getUsuario(abonadoId));
    } else dispatch(generalActions.dashboard_changeTitle('NUEVO ABONADO'));
  }
  componentWillUnmount = () => {
    this.props.dispatch(abonadosActions.clear('abonado'));
    this.props.dispatch(abonadosActions.clear('abonadoLastAbonos'));
    this.props.dispatch(abonadosActions.clear('reservasUsuario'));
  };
  componentWillReceiveProps(nextProps) {
    const {
      params: { abonadoId, isUser },
      dispatch,
      abonado,
    } = this.props;
    if (abonadoId != 'new' && abonado.size == 0) {
      if (!this.props.userRoles.equals(nextProps.userRoles) && checkPermissions(['admin', 'administrador_abonados', 'administrador_pasajes']))
        dispatch(abonadosActions.getById(abonadoId, isUser == 'true'));
    }
  }
  newAbono = () => this.setState({ popupFlag: true });
  submitForm = (data) => {
    const {
      params: { abonadoId, isUser },
      dispatch,
    } = this.props;
    data = formatData(data.toJS());
    dispatch(abonadosActions.set(data.data, abonadoId, isUser == 'true', data.usuarioExtension));
  };
  desabilitarFechas(date, hasta = false) {
    if (!hasta && moment(date).startOf('day').toDate() < moment().startOf('day').subtract(1, 'day').toDate().getTime()) return true;
    else if (hasta && moment(date).startOf('day').toDate() < moment(this.props.noReservarDesde).startOf('day').subtract(1, 'day').toDate().getTime()) return true;
    else return false;
  }
  editReserva = (id, viajeId) => this.props.dispatch(push(`/dashboard/reservas/add/${id}/${viajeId}`));
  confirmCancelarReserva = () => {
    const {
      dispatch,
      params: { abonadoId, isUser },
    } = this.props;
    if (this.state.cancelarId) dispatch(reservasActions.cancelarReserva(this.state.cancelarId, true, null, { abonadoId, isUser: isUser == 'true' }));
    this.setState({ cancelarId: false });
  };
  concretarReserva = (reservaId, concretar, viajeId) => {
    const {
      dispatch,
      params: { abonadoId, isUser },
    } = this.props;
    dispatch(reservasActions.concretarReserva(reservaId, concretar, viajeId, { abonadoId, isUser: isUser == 'true' }));
  };
  abonarReserva = (reservaId, abonada, viajeId, cuentaCorriente, penalizacion) => {
    if (!penalizacion || penalizacion.size == 0) this.props.dispatch(reservasActions.abonarReserva(reservaId, abonada, viajeId, cuentaCorriente));
    else this.props.dispatch(penalizacionesActions.setState({ showListaPenalizaciones: true, penalizacionesUsuario: penalizacion }));
  };
  cancelarReserva = (reservaId) => this.setState({ cancelarId: reservaId ? reservaId : false });
  getMessages = (fecha) => {
    this.props.dispatch(mensajesActions.getUsuario(this.props.params.abonadoId, moment(fecha).format()));
  };
  buscarUsuario = (val, doc) => {
    if (doc.length >= 7) this.props.dispatch(abonadosActions.getByDoc(doc, FORM_ABONADOS));
  };
  deleteInit = (abonadoId) => this.setState({ eliminarId: abonadoId ? abonadoId : false });
  deleteAbonado = () => {
    this.props.dispatch(abonadosActions.deleteAbonado(this.state.eliminarId));
    this.setState({ eliminarId: false });
  };
  render() {
    const {
        abonado,
        lastAbonos,
        params: { abonadoId, isUser },
        handleSubmit,
        pristine,
        invalid,
        reservasUsuario,
        mensajesList,
        blockForm,
      } = this.props,
      { popupFlag, eliminarId } = this.state;

    return (
      <Container fluid={true}>
        <Row>
          <Col>
            <MaterialUI.Paper zDepth={2} className="padding p-lr-10">
              <Container fluid={true}>
                <Row>
                  {isUser == 'false' && abonado && abonado.get('eliminado') && (
                    <Col md="12">
                      <h2 className="mtp-20 unavailable">ABONADO ELIMINADO</h2>
                    </Col>
                  )}
                  <Col md="4">
                    <Field
                      name="documento"
                      component={TextFieldF}
                      inputProps={{
                        autoFocus: abonadoId == 'new',
                        fullWidth: true,
                        floatingLabelText: 'Documento',
                        hintText: 'Ingresa el documento del abonado',
                        disabled: abonadoId != 'new' ? true : false,
                      }}
                      onChange={this.buscarUsuario.bind(this)}
                      validate={[validations.required, validations.maxLength8, validations.minLength7]}
                    />
                  </Col>
                  <Col md="4">
                    <Field
                      name="nombre"
                      component={TextFieldF}
                      inputProps={{
                        fullWidth: true,
                        floatingLabelText: 'Nombre',
                        hintText: 'Ingresa el nombre del abonado',
                        disabled: abonadoId != 'new' && isUser == 'true' ? true : false,
                      }}
                      validate={[validations.required, validations.minLength3, validations.maxLength50]}
                    />
                  </Col>
                  <Col md="4">
                    <Field
                      name="apellido"
                      component={TextFieldF}
                      inputProps={{
                        fullWidth: true,
                        floatingLabelText: 'Apellido',
                        hintText: 'Ingresa el apellido del abonado',
                        disabled: abonadoId != 'new' && isUser == 'true' ? true : false,
                      }}
                      validate={[validations.required, validations.minLength2, validations.maxLength50]}
                    />
                  </Col>
                </Row>
              </Container>
            </MaterialUI.Paper>
          </Col>
        </Row>
        <Row>
          <Col>
            <MaterialUI.Paper zDepth={2} className="padding">
              <MaterialUI.Tabs initialSelectedIndex={3}>
                <MaterialUI.Tab label="Datos del usuario">
                  <Row className="rowContainer">
                    {isUser == 'false' && (
                      <Col md="4">
                        <Field
                          name="email"
                          component={TextFieldF}
                          inputProps={{
                            fullWidth: true,
                            floatingLabelText: 'Email',
                            hintText: 'Ingresa el email del abonado',
                            disabled: isUser == 'true',
                          }}
                          validate={[validations.email]}
                        />
                      </Col>
                    )}
                    {isUser == 'false' && (
                      <Col md="4">
                        <Field
                          name="telefono"
                          component={TextFieldF}
                          inputProps={{
                            fullWidth: true,
                            floatingLabelText: 'Telefono',
                            hintText: 'Ingresa el telefono del abonado',
                            disabled: abonadoId != 'new' && isUser == 'true' ? true : false,
                          }}
                          validate={[validations.number, validations.minLength3, validations.maxLength50]}
                        />
                      </Col>
                    )}
                    <Col md="4">
                      <Field
                        name="tipoDoc"
                        component={SelectFieldF}
                        inputProps={{
                          fullWidth: true,
                          autoWidth: true,
                          floatingLabelText: 'Tipo de documento',
                          disabled: abonadoId != 'new' && isUser == 'true' ? true : false,
                        }}
                      >
                        <MaterialUI.MenuItem value={'DNI'} primaryText="DNI" />
                        <MaterialUI.MenuItem value={'otro'} primaryText="Otro" />
                      </Field>
                    </Col>
                    <Col md="4">
                      <Field
                        name="observaciones"
                        component={TextFieldF}
                        inputProps={{
                          fullWidth: true,
                          floatingLabelText: 'Observaciones',
                          hintText: 'Ingresa una observacion del abonado',
                          multiLine: true,
                          rows: 1,
                          rowsMax: 2,
                        }}
                        validate={[validations.maxLength200]}
                      />
                    </Col>
                    <FormSection className="fullWidthComponent row" name="usuarioExtension">
                      <Col md="4">
                        <Field
                          name="noReservarDesde"
                          component={DatePickerF}
                          format={(value) => (typeof value == 'string' ? null : value)}
                          inputProps={{
                            autoOk: true,
                            fullWidth: true,
                            floatingLabelText: 'No reservar desde',
                            shouldDisableDate: (date) => this.desabilitarFechas(date),
                          }}
                        />
                      </Col>
                      <Col md="4">
                        <Field
                          name="noReservarHasta"
                          component={DatePickerF}
                          format={(value) => (typeof value == 'string' ? null : value)}
                          inputProps={{
                            autoOk: true,
                            fullWidth: true,
                            floatingLabelText: 'No reservar hasta',
                            shouldDisableDate: (date) => this.desabilitarFechas(date, true),
                          }}
                        />
                      </Col>
                      <Col md="4">
                        <Field
                          name="permisoDeReservaEliminado"
                          component={ToggleFieldF}
                          inputProps={{
                            label: 'Eliminar derecho a reservar',
                            className: 'fullWidthComponent p10 redBorder m-top-50',
                          }}
                        />
                      </Col>
                      <Col md="4">
                        <Field
                          name="ordenPrioridadReservasAutomaticas"
                          component={SelectFieldF}
                          inputProps={{
                            autoWidth: true,
                            floatingLabelText: 'Prioridad reservas automaticas',
                          }}
                        >
                          <MaterialUI.MenuItem value={0} primaryText="Sin prioridad" />
                          <MaterialUI.MenuItem value={1} primaryText="1 - Prioridad más alta" />
                          <MaterialUI.MenuItem value={2} primaryText="2" />
                          <MaterialUI.MenuItem value={3} primaryText="3" />
                          <MaterialUI.MenuItem value={4} primaryText="4" />
                          <MaterialUI.MenuItem value={5} primaryText="5" />
                        </Field>
                      </Col>
                    </FormSection>
                  </Row>
                  {checkPermissions(['admin', 'administrador_pasajes', 'administrador_abonados']) && (
                    <MaterialUI.RaisedButton
                      className="fullWidthComponent noPadding m-tb-20"
                      label="GUARDAR"
                      primary={true}
                      disabled={pristine || invalid || blockForm || (abonado && abonado.get('eliminado'))}
                      onClick={handleSubmit(this.submitForm)}
                    />
                  )}
                  {isUser == 'false' && abonadoId != 'new' && (
                    <MaterialUI.RaisedButton
                      className="fullWidthComponent noPadding m-tb-20"
                      icon={<MaterialUI.FontIcon className="fa fa-trash" />}
                      label="ELIMINAR ABONADO"
                      secondary={true}
                      disabled={invalid || blockForm || (abonado && abonado.get('eliminado'))}
                      onClick={() => this.deleteInit(abonadoId)}
                    />
                  )}
                </MaterialUI.Tab>
                <MaterialUI.Tab label="Reservas Automáticas">
                  <ReservasAutomaticasTableC abonadoId={abonadoId} isUser={isUser == 'true'} />
                </MaterialUI.Tab>
                <MaterialUI.Tab label="Abonos">
                  {this.props.params.abonadoId != 'new' && checkPermissions(['admin', 'administrador_pasajes']) && (
                    <Col md="12" className="m-tb-20">
                      {!lastAbonos || lastAbonos.size <= 0 ? (
                        <Row>
                          <Col md="12" className="textCenter">
                            <h2 className="p10">No posee ningun abono</h2>
                          </Col>
                        </Row>
                      ) : (
                        <MaterialUI.List className="noPadding dividerList">
                          {lastAbonos.map((abono) => (
                            <AbonoItemListC key={abono.get('id')} abono={abono} isUser={isUser == 'true'} />
                          ))}
                        </MaterialUI.List>
                      )}
                    </Col>
                  )}
                  <MaterialUI.RaisedButton disabled={abonadoId == 'new'} className="fullWidthComponent noPadding m-tb-20" label="NUEVO ABONO" primary={true} onClick={() => this.newAbono()} />
                </MaterialUI.Tab>
                <MaterialUI.Tab label="Reservas">
                  {reservasUsuario.size == 0 && (
                    <Row>
                      <Col md="12" className="textCenter m-tb-20">
                        <h2 className="p10">No posee ninguna reserva</h2>
                      </Col>
                    </Row>
                  )}
                  {reservasUsuario.map((reserva) => (
                    <Row key={reserva.get('id')}>
                      <Col md="3">
                        <MaterialUI.Divider />
                        <MaterialUI.ListItem
                          leftIcon={<MaterialUI.FontIcon className="fa fa-calendar" />}
                          primaryText={moment(reserva.get('horarioViaje')).format('DD/MM HH:mm')}
                          secondaryText={`${reserva.getIn(['_trayecto', 'nombre'])} ${reserva.getIn(['_trayecto', 'subnombre']) || ''}`}
                          onClick={() => this.props.dispatch(push('/dashboard/reservas/pasajeros/' + reserva.get('viajeId')))}
                        />
                      </Col>
                      <Col md="8">
                        <MaterialUI.Divider />
                        <ItemListPasajeroC
                          cancelarReserva={() => this.cancelarReserva(reserva.get('id'))}
                          editReserva={(id) => this.editReserva(id, reserva.get('viajeId'))}
                          abonarReserva={this.abonarReserva}
                          concretarReserva={this.concretarReserva}
                          reservaPasajero={reserva}
                        />
                      </Col>
                      <Col md="1">
                        <MaterialUI.ListItem
                          primaryText={
                            <Row>
                              <Col md="6">
                                <MaterialUI.FontIcon className="fa fa-users" />
                              </Col>
                              <Col md="6">
                                <h4>{reserva.get('_acompanantes').size}</h4>
                              </Col>
                            </Row>
                          }
                        />
                      </Col>
                    </Row>
                  ))}
                  <MaterialUI.RaisedButton
                    disabled={abonadoId == 'new'}
                    className="fullWidthComponent noPadding m-tb-20"
                    label="ACTUALIZAR RESERVAS"
                    primary={true}
                    onClick={() => this.props.dispatch(abonadosActions.getReservasUsuario(abonadoId, isUser == 'true'))}
                  />
                </MaterialUI.Tab>
                <MaterialUI.Tab label="Mensajes">
                  <Row>
                    <Col md="3">
                      <h5 className="pt-10">Fecha de los mensajes </h5>
                    </Col>
                    <Col md="6">
                      <MaterialUI.DatePicker
                        autoOk
                        name="fecha"
                        locale="es"
                        DateTimeFormat={DateTimeFormat}
                        defaultDate={moment().toDate()}
                        hintText="Fecha de los mensajes"
                        onChange={(val, fecha) => this.getMessages(fecha)}
                      />
                    </Col>
                    <Col>
                      <MaterialUI.Divider />
                    </Col>
                  </Row>
                  <MaterialUI.List className="noPadding dividerList">
                    {mensajesList.map((mensaje) => (
                      <Row key={mensaje.get('id')}>
                        <Col>
                          <MaterialUI.ListItem
                            primaryText={`${moment(mensaje.get('fechaEmision')).format('DD/MM/YY HH:mm')}hs`}
                            secondaryText={<p>{mensaje.get('mensaje')}</p>}
                            secondaryTextLines={2}
                          />
                        </Col>
                        <Col>
                          <MaterialUI.Divider />
                        </Col>
                      </Row>
                    ))}
                  </MaterialUI.List>
                </MaterialUI.Tab>
              </MaterialUI.Tabs>
            </MaterialUI.Paper>
          </Col>
        </Row>
        <MaterialUI.Dialog
          title={`Nuevo abono para ${abonado.get('nombre')} ${abonado.get('apellido')} `}
          modal={false}
          autoScrollBodyContent={true}
          open={popupFlag}
          onRequestClose={() => this.setState({ popupFlag: false })}
        >
          <AbonosC abonadoId={abonadoId} isUser={isUser == 'true'} close={() => this.setState({ popupFlag: false })} />
        </MaterialUI.Dialog>
        <CancelarButtonC className="m-tb-20" dispatch={this.props.dispatch} />
        <EliminarConfirmacionC
          eliminarId={eliminarId}
          cancelar={this.deleteInit}
          confirmar={this.deleteAbonado}
          content="¿Está seguro de querer eliminar este usuario? Está acción no se puede revertir"
        />
        <EliminarConfirmacionC eliminarId={this.state.cancelarId} cancelar={this.cancelarReserva} confirmar={this.confirmCancelarReserva} />
        <PenalizacionesUsuarioC />
      </Container>
    );
  }
}

function formatData(data) {
  let dataClon = Object.assign({}, data),
    usuarioExtension = dataClon.usuarioExtension;
  usuarioExtension.observaciones = data.observaciones;
  delete dataClon.usuarioExtension;
  delete dataClon.observaciones;
  return { data: dataClon, usuarioExtension };
}

Add = reduxForm({
  form: FORM_ABONADOS,
  enableReinitialize: true,
})(Add);

Add = connect((store) => {
  let noReservarDesde = store.getIn(['abonados', 'abonado', '_usuarioExtension', 'noReservarDesde']),
    noReservarHasta = store.getIn(['abonados', 'abonado', '_usuarioExtension', 'noReservarHasta']);
  return {
    userRoles: store.getIn(['user', 'roles']),
    abonado: store.getIn(['abonados', 'abonado']),
    lastAbonos: store.getIn(['abonados', 'abonadoLastAbonos']),
    noReservarDesde: selector(store, 'noReservarDesde'),
    reservasUsuario: store.getIn(['abonados', 'reservasUsuario']),
    mensajesList: store.getIn(['mensajes', 'listaUsuario']),
    blockForm: store.getIn(['abonados', 'blockForm']),
    initialValues: {
      email: store.getIn(['abonados', 'abonado', 'email']),
      nombre: store.getIn(['abonados', 'abonado', 'nombre']),
      tipoDoc: store.getIn(['abonados', 'abonado', 'tipoDoc']) || 'DNI',
      apellido: store.getIn(['abonados', 'abonado', 'apellido']),
      telefono: store.getIn(['abonados', 'abonado', 'telefono']),
      documento: store.getIn(['abonados', 'abonado', 'documento']),
      observaciones: store.getIn(['abonados', 'abonado', '_usuarioExtension', 'observaciones']),
      usuarioExtension: {
        observaciones: store.getIn(['abonados', 'abonado', '_usuarioExtension', 'observaciones']),
        noReservarDesde: noReservarDesde ? new Date(noReservarDesde) : undefined,
        noReservarHasta: noReservarHasta ? new Date(noReservarHasta) : undefined,
        permisoDeReservaEliminado: store.getIn(['abonados', 'abonado', '_usuarioExtension', 'permisoDeReservaEliminado']),
        ordenPrioridadReservasAutomaticas: store.getIn(['abonados', 'abonado', '_usuarioExtension', 'ordenPrioridadReservasAutomaticas']),
      },
    },
  };
})(Add);

export default Add;



// WEBPACK FOOTER //
// src/modules/abonados/components/add.js